import React from 'react';
import { Card, Grid, Icon, Page } from 'tabler-react';
import RemoveLastDirectoryPartOf from '../goBackButton';
import { useAPI } from '../../ApiCalls/useAPI';

class Attendance extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            postId: null,
            session: null
        };
    }
    checkResponse(data) {
        this.setState({
            data: data,
            session: data.attandance.dayobjects[0]
        });
    }
    componentDidMount() {
        const { getAttendance } = useAPI();
        getAttendance()
            .then((response) => this.checkResponse(response))
            .catch((error) => console.error(error));
    }

    render() {
        let dailyatt, day, updatedon, last2weeks, overall;
        if (this.state.session == null) {
            dailyatt = <NoAttendance />;
            last2weeks = dailyatt;
            day = '--';
            updatedon = '--';
        } else {
            dailyatt = <AttendanceCard data={this.state.session} />;
            {console.log(this.state.session,'session')}
            last2weeks = [];
            overall = [];
            for (
                var i = 1;
                i < this.state.data.attandance.dayobjects.length;
                i++
            ) {
                last2weeks.push(
                    <TwoWeeksAttendanceCard
                        data={this.state.data.attandance.dayobjects[i]}
                    />
                );
            }
            last2weeks.push(
                <table className="mt-2" style={{ width: '100%' }}>
                    <tbody>
                        <tr>
                            <td style={{ textAlign: 'right' }}>
                                <DayAttendance data="1"></DayAttendance>
                            </td>
                            <td>
                                {
                                    this.state.data.attandance.twoweeksessions
                                        .present
                                }
                            </td>
                            <td style={{ textAlign: 'right' }}>
                                <DayAttendance data="0"></DayAttendance>
                            </td>
                            <td>
                                {
                                    this.state.data.attandance.twoweeksessions
                                        .absent
                                }
                            </td>
                            <td style={{ textAlign: 'right' }}>
                                <DayAttendance data="2"></DayAttendance>
                            </td>
                            <td>
                                {
                                    this.state.data.attandance.twoweeksessions
                                        .nosessions
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
            day = this.state.session.day;
            updatedon = this.state.session.updatedon;
            // console.log(updatedon)
            overall.push(
                <OverallAttendanceCard
                    data={this.state.data.overallattperformance}
                />
            );
            overall.push(
                <OverallAttendanceMeter
                    data={this.state.data.overallattperformance.totalpercentage}
                />
            );
        }

        let a1 = <Card.Body>{dailyatt}</Card.Body>;        
        let a2 = <Card.Body>{last2weeks}</Card.Body>;
        let a3 = <Card.Body>{overall}</Card.Body>;
        return (
            <Page.Content className="attendance">
                <div
                    className="m-2"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Attendance</div>
                </div>
                <Grid.Row>
                    <Grid.Col xs={12} sm={12} md={12} xl={12}>
                        <Card isCollapsible title={day} body={a1} />
                    </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Col xs={12} sm={12} md={12} xl={12}>
                        <Card
                            isCollapsible
                            isCollapsed
                            title="Last 2 Weeks"
                            body={a2}
                        />
                    </Grid.Col>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Col xs={12} sm={12} md={12} xl={12}>
                        <Card
                            isCollapsible
                            isCollapsed
                            title="Overall"
                            body={a3}
                        />
                    </Grid.Col>
                </Grid.Row>
            </Page.Content>
        );
    }
}

class NoAttendance extends React.Component {
    render() {
        return <div>No attendance available</div>;
    }
}

class AttendanceCard extends React.Component {
    render() {
        // console.log(this.props.data, '&$$');
        if (this.props.data) {
            return (
                <div>
                    <DayAttendance data={this.props.data.sessions.session1} />
                    <DayAttendance data={this.props.data.sessions.session2} />
                    <DayAttendance data={this.props.data.sessions.session3} />
                    <DayAttendance data={this.props.data.sessions.session4} />
                    <DayAttendance data={this.props.data.sessions.session5} />
                    <DayAttendance data={this.props.data.sessions.session6} />
                    <DayAttendance data={this.props.data.sessions.session7} />
                    <div>{this.props.data.updatedon}</div>
                </div>
            );
        } else {
            // console.log(this.props, '%');
            return <div>No attendance.</div>;
        }
    }
}

class TwoWeeksAttendanceCard extends React.Component {
    render() {
        // console.log(this.props.data, '&$$');
        if (this.props.data) {
            return (
                <div>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '50%' }}>
                                    {this.props.data.date}
                                </td>
                                <td>
                                    <DayAttendance
                                        data={this.props.data.sessions.session1}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session2}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session3}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session4}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session5}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session6}
                                    />
                                    <DayAttendance
                                        data={this.props.data.sessions.session7}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        } else {
            return <div>No attendance.</div>;
        }
    }
}

class DayAttendance extends React.Component {
    render() {
        // console.log(this.props.data);
        switch (this.props.data) {
            case '0':
                return (
                    <Icon prefix="fe" name="x-circle" className="red"></Icon>
                );
            case '1':
                return (
                    <Icon prefix="fe" name="check-circle" className="green" />
                );
            case '2':
                return <Icon prefix="fe" name="circle" />;
            default:
                return <Icon prefix="fe" name="circle" />;
        }
    }
}

class OverallAttendanceCard extends React.Component {
    render() {
        // console.log('this.props.data', this.props.data);
        var overall = [];
        for (var i = 0; i < this.props.data.overall.length; i++) {
            overall.push(
                <OverallAttendanceSubjectCard
                    subject={this.props.data.overall[i]}
                />
            );
        }

        return (
            <table style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th>Subject</th>
                        <th>Theory(%)</th>
                        <th>Practicals(%)</th>
                    </tr>
                </thead>
                <tbody>{overall}</tbody>
            </table>
        );
    }
}

class OverallAttendanceSubjectCard extends React.Component {
    render() {
        return (
            <tr>
                <td>{this.props.subject.subjectname}</td>
                <td>
                    <meter
                        min="0"
                        max="100"
                        value={this.props.subject.percentage}
                    />
                </td>
                <td>
                    <meter
                        min="0"
                        max="100"
                        value={this.props.subject.practical}
                    />
                </td>
            </tr>
        );
    }
}

class OverallAttendanceMeter extends React.Component {
    render() {
        let k = this.props.data;
        return (
            <table className="mt-6" style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th style={{ width: '50%' }}>Overall</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={{ width: '50%' }}>
                            <meter
                                low="74"
                                optimum="75"
                                high="80"
                                style={{ width: '100%' }}
                                min="0"
                                max="100"
                                value={k}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

export default Attendance;
